// Espejo de src/lib/tarifaDigital.js: la pasarela la asume el cliente.
export const PORCENTAJE = 0.046922;
export const NOMBRE = 'Tarifa de servicio digital';

export const cobroCon = (base) => {
    const valor = Math.round(Number(base) || 0);
    return valor > 0 ? Math.round(valor / (1 - PORCENTAJE)) : 0;
};

export const desglose = (base) => {
    const valor = Math.round(Number(base) || 0);
    const total = cobroCon(valor);
    return { base: valor, tarifa: total - valor, total };
};
